// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-list[data-v-1d3ad4f0]{height:300px;overflow-y:auto}.custom-text-field>.v-input__control>.v-input__slot[data-v-1d3ad4f0]{min-height:20px!important;padding:0 12px}.custom-text-field>.v-input__control>.v-input__slot .v-input__append-inner[data-v-1d3ad4f0]{margin-top:5px!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
